import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import MediaSection from './components/MediaSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import FaqSection from './components/FaqSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <CardsSection />
        <TopicsSection />
        <FeaturesSection />
        <CarouselSection />
        <ContactSection />
        <UpdatesSection />
        <MediaSection />
        <IndexSection />
        <RankingSection />
        <AboutSection />
        <CommentsSection />
        <AppSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}